/**
 * 目的地のテキスト検索（ジオコーディング）。
 *
 * 実際の問い合わせはWorker `/v1/geocode` 経由でOpenStreetMap Nominatimへ行う
 * （User-Agent付与とKVキャッシュのため）。ここには端末・Worker双方で共有する
 * クエリ正規化と応答パースだけを置く。
 *
 * 送信するのはユーザーが入力した地名だけで、GPS軌跡や現在地は送らない（§2）。
 */

export interface GeoResult {
  /** 表示用の短い名前（例：「根津美術館」） */
  name: string;
  /** 完全な住所（例：「根津美術館, 南青山, 港区, 東京都, 日本」） */
  fullName: string;
  lat: number;
  lon: number;
}

/** 検索クエリの正規化（キャッシュキー兼用）。空・長すぎる入力は null */
export function normalizeGeoQuery(q: string): string | null {
  const s = q.trim().replace(/\s+/g, " ").slice(0, 120);
  return s.length > 0 ? s : null;
}

/** Nominatim（format=jsonv2）応答のパース＋検証。不正な要素は捨てる */
export function parseGeoResults(raw: unknown): GeoResult[] {
  if (!Array.isArray(raw)) return [];
  const out: GeoResult[] = [];
  for (const item of raw) {
    if (!item || typeof item !== "object") continue;
    const o = item as Record<string, unknown>;
    const lat = Number(o.lat);
    const lon = Number(o.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) continue;
    if (lat < -90 || lat > 90 || lon < -180 || lon > 180) continue;
    const fullName = typeof o.display_name === "string" ? o.display_name : "";
    const shortName =
      typeof o.name === "string" && o.name.length > 0
        ? o.name
        : (fullName.split(",")[0] ?? "").trim();
    if (!shortName) continue;
    out.push({ name: shortName, fullName: fullName || shortName, lat, lon });
  }
  return out;
}
